export default {
  hello: 'Привет',
  page: {
    example: 'Тестовая страница {name}'
  },
  other: 'Прочее',
  searchByNameProduct: 'Поиск по названию блюда',
  nothingFound: 'Ничего не найдено',
  login: 'Логин',
  password: 'Пароль',
  chooseLanguage: 'Выберите язык',
  restaurantWifi: 'Wi-Fi заведения',
  chipDialog: {
    gotIt: 'Понятно',
    cashback: {
      title: 'Кэшбэк',
      description: 'Возврат средств при оплате в заведении.'
    },
    rating: {
      title: 'Рейтинг',
      description: 'Оценка заведения по отзывам гостей.'
    },
    avgBill: {
      title: 'Средний чек',
      description: 'Средняя стоимость заказа на персону.'
    },
    workingHours: {
      title: 'Часы работы',
      description: 'Расписание работы заведения.'
    },
    address: {
      title: 'Адрес',
      description: 'Расположение заведения.'
    },
    openingHours: {
      title: 'Время работы',
      description: 'Сейчас заведение открыто или закрыто и когда откроется или закроется.'
    },
    avgCooking: {
      title: 'Время приготовления',
      description: 'Ориентировочное время приготовления заказа.'
    },
    venueInfo: {
      title: 'О заведении',
      description:
        'Краткая справка о заведении: название и данные из меню. Подробности можно уточнить у персонала.'
    }
  },
  venueInfoModal: {
    close: 'Закрыть',
    scheduleMode: 'Режим работы',
    call: 'Позвонить',
    route: 'Маршрут',
    taxi: 'Такси',
    prep: 'Приготовление',
    delivery: 'Доставка',
    avgCheck: 'Средний чек',
    rating: 'Рейтинг',
    todaySuffix: ' (Сегодня)',
    weekdays: {
      mon: 'Понедельник',
      tue: 'Вторник',
      wed: 'Среда',
      thu: 'Четверг',
      fri: 'Пятница',
      sat: 'Суббота',
      sun: 'Воскресенье'
    }
  },
  qrMenu: {
    passwordResetSuccessfully: 'Пароль успешно сброшен',
    unableToResetPassword: 'Не удалось сбросить пароль',
    shareText: 'Посмотри меню',
    openUntil: 'Открыто до {time}',
    opensAt: 'Откроется в {time}',
    cookingMinutes: '{n} мин',
    avgBillApprox: '~{amount} сум',
    menuLoadErrorTitle: 'Не удалось загрузить меню',
    sourceCart: 'Корзина',
    sourceMenu: 'Меню',
    orderLoadFailedTitle: 'Не удалось загрузить заказ',
    orderPlaceFailedTitle: 'Не удалось оформить заказ',
    yourOrder: 'Ваш заказ',
    yourLastOrder: 'Посмотреть ваш заказ',
    dishNames: 'Наименования блюд',
    noOrderItems: 'Нет позиций в заказе',
    summaryInfo: 'Сводная информация',
    orderSum: 'Сумма заказа',
    currencySuffix: 'сум',
    orderPriceItems: '{count} товаров',
    orderPriceAction: 'Заказать',
    backToHome: 'Вернуться на главную',
    cartSectionAria: 'Корзина',
    paymentSectionAria: 'Способ оплаты',
    totalToPay: 'Итого к оплате:',
    cartEmpty: 'Ваш заказ пуст',
    authDialogTitle: 'Авторизация',
    storiesAlt: 'Сторис',
    back: 'Назад',
    orderUuidMissing: 'Не указан идентификатор заказа',
    orderLoadFailed: 'Не удалось загрузить заказ',
    orderParseFailed: 'Не удалось разобрать ответ заказа',
    tableOrderMissingTableId: 'Не указан стол (параметр ссылки). Отсканируйте QR стола снова.',
    orderErrorNoDetails: 'Заказ не удалось обработать. Попробуйте ещё раз или обратитесь в заведение.',
    orderTableProgress: {
      awaiting: 'Заказ создан',
      awaiting_description: 'Ожидаем подтверждения от ресторана',
      preparing: 'Ресторан начал готовить блюдо',
      preparing_description: 'Скоро будет готово',
      prepared: 'Блюдо готово',
      prepared_description: 'Курьер скоро заберет заказ',
      delivering: 'Курьер доставляет заказ',
      delivering_description: 'Скоро будет на месте',
      ready: 'Заказ доставлен',
      ready_description: 'Приятного аппетита'
    },
    cartPayment: {
      addCard: 'Добавить карту',
      addCardPlaceholder: 'Добавить карту',
      expiryPlaceholder: 'ММ/ГГ',
      pay: 'Оплатить',
      savedCardAria: 'Карта {pan}',
      orDivider: 'ИЛИ',
      addCardFailed: 'Не удалось добавить карту',
      invalidCardNumber: 'Неверный номер карты',
      invalidCardExpiry: 'Неверный срок действия карты'
    },
    cartComment: {
      title: 'Комментарий ресторану',
      placeholder: 'Пожелания по заказу, аллергии и т.д.',
      done: 'Готово'
    },
    cartHeader: {
      backToMenuAria: 'Назад в меню',
      clearCartAria: 'Очистить корзину'
    },
    cartActions: {
      addMore: 'Добавить еще блюда'
    },
    cardAddFlow: {
      verifyTitle: 'Подтверждение карты',
      verifyHint: 'Введите 6-значный код из SMS',
      confirm: 'Подтвердить',
      addTitle: 'Добавить карту',
      addHint: 'Введите номер карты и срок действия',
      cardNumberPlaceholder: 'Номер карты'
    },
    check: {
      yourBill: 'Ваш счет',
      billNumber: 'Счёт №{n}',
      waiter: 'Официант',
      tableNumber: 'Номер стола',
      tableLabel: 'стол {n}',
      tipsHeading: 'Чаевых официанту',
      noTip: 'Без чаевых',
      saveTipNext: 'Сохранить размер чаевых для следующего заказа',
      paymentMethod: 'Способ оплаты',
      summaryHeading: 'Сводная информация',
      rowOrder: 'Заказ',
      rowTips: 'Чаевые',
      total: 'Всего',
      continue: 'Продолжить',
      disclaimer:
        'Rachmat выступает посредником в сделке между вами, заведением и поставщиком услуг доставки. Подтверждая, вы принимаете наши Положения и условия и даете нам разрешение на обработку заказа.',
      demoRestaurant: 'Ресторан Азиатской Кухни',
      demoWaiter: 'Azamat',
      demoTableNumber: '5'
    },
    orderPaymentOtp: {
      title: 'Подтверждение оплаты',
      hint: 'Введите код из SMS',
      confirm: 'Подтвердить',
      resendFailed: 'Не удалось отправить код повторно',
      resendSent: 'Код отправлен повторно',
      missingCardToken: 'Не найден токен карты для повторной отправки кода',
      cardConfirmed: 'Карта успешно добавлена',
      confirmFailed: 'Неверный код или срок действия карты истёк'
    },
    confirmClearCart: {
      message: 'Вы уверены что хотите очистить корзину с прошлого раза?',
      header: 'Очистка корзины',
      cancel: 'Отмена',
      accept: 'Очистить'
    },
    confirmPaymentFailed: 'Не удалось подтвердить оплату',
    restaurantClosed: {
      title: 'Ресторан временно закрыт',
      description: 'В данный момент ресторан не принимает заказы. Попробуйте чуть позже.',
      retry: 'Повторить'
    },
    confirmPaymentOtpFailed: 'Неверный код или платёж не подтверждён',
    auth: {
      welcome: 'Добро пожаловать',
      phoneIntro: 'Начнем с вашего номера телефона',
      phoneLabel: 'Номер телефона',
      smsTitle: 'SMS код',
      smsHintLine1: 'Введите 4-значный код, который мы отправили',
      smsHintLine2: 'вам в SMS по номеру {phone}',
      resendPrefix: 'Отправить снова через',
      sendAgain: 'Отправить',
      getSmsCode: 'Получить SMS-код',
      signIn: 'Войти',
      termsLine1: 'Создавая учетную запись, вы автоматически принимаете наши Условия обслуживания,',
      termsPrivacy: 'Политику конфиденциальности',
      termsAnd: 'и',
      termsCookie: 'Политику использования файлов cookie.'
    }
  },
  toast: {
    success: 'Успешно',
    error: 'Ошибка',
    loginCopied: 'Логин скопирован',
    passwordCopied: 'Пароль скопирован',
    productUnavailableSummary: 'Товар недоступен',
    productUnavailableDetail: 'Временно недоступен'
  },
  redirectWindow: {
    openButton: 'Экран перехода к оплате',
    continueTo: 'Оплата в приложении {system}',
    redirectHint: 'Вы будете перенаправлены в приложение {system} для подтверждения транзакции',
    cancelPayment: 'Отменить'
  }
}
